// Launch-phase feature flags. Shared by the app and the marketing site.
//
// INVITE_ONLY_MODE gates the first ~30 days: marketing shows "Join the
// waitlist" instead of the subscribe CTA, and sign-up requires a valid invite
// code. Phase H Section B hardcodes this to true; Section C ties it to an
// environment variable so it can be flipped without a deploy of new code.
export const INVITE_ONLY_MODE = true;

// Monthly metered-read allowance for a free account. Single source of truth for
// both the app's read gate (free_read_status / consume_free_read) and the
// marketing gate card's copy, so the two never drift.
//
// This governs UI copy only. It must match `v_limit` (currently 5) hardcoded in
// get_article_render / free_read_status / consume_free_read — the server-side
// enforcement — in the metered_archive migration. Change both together; the
// reciprocal SQL comment rides whichever future migration next touches those
// functions (applied migration files are never edited in place).
export const FREE_READ_LIMIT = 5;

// Monthly free-play allowance for a free account (VOD). Single source of truth
// for the app's play gate (free_play_status / consume_free_play) and the
// marketing video gate card's copy, so the two never drift.
export const FREE_PLAY_LIMIT = 5;
